export default "skymp5-front/29359f1c6135098e82121dce53128a35.svg";